import angular from 'angular'
import simulateEvent from 'simulate-event'

import { toPosPixel } from './bits'

import viewportResize from './viewport-resize'
import getScrollbarSize from './get-scrollbar-size'

angular
  .module('ggs.utils')
  .factory('htmlOverflowY', htmlOverflowYProvider)

function htmlOverflowYProvider(domh, addIdPrefix) {

  const body = document.body
  const html = document.documentElement
  const scrollbarWidth = getScrollbarSize()

  const hiddenClass = addIdPrefix('html-overflow-y__hidden')
  const replacerClass = addIdPrefix('html-overflow-y__replacer')

  const style = domh.createStyle(addIdPrefix('html-overflow-y')).global.important(`
    html.${hiddenClass},
    html.${hiddenClass} body {
      width: auto;
      height: auto;
      overflow-y: hidden;
    }

    html.${replacerClass},
    html.${replacerClass} .gcap.gcap-layout-floating,
    html.${replacerClass} .gcap.gcap-layout-bar .gcap-body,
    html.${replacerClass} .gcap.gcap-layout-popup .gcap-form,
    html.${replacerClass} .gcap.gcap-layout-takeover .gcap-form {
      margin-right: ${toPosPixel(scrollbarWidth)};
    }`)

  function attachStyles() {
    style.attach()
    viewportResize.manualCheck()
  }

  function detachStyles() {
    style.detach()
    viewportResize.manualCheck()
  }

  function hidden() {
    if (isScrollbarVisible()) {
      html.classList.add(replacerClass)
    }
    html.classList.add(hiddenClass)
    viewportResize.manualCheck()
  }

  function auto() {
    html.classList.remove(replacerClass)
    html.classList.remove(hiddenClass)
    viewportResize.manualCheck()
    simulateEvent.simulate(document, 'scroll')
  }

  return {
    auto,
    hidden,
    attachStyles,
    detachStyles
  }

  // helpers

  function isScrollbarVisible() {
    const viewportHeight = viewportResize.getHeight()
    const documentHeight = domh.getDocumentHeight()
    const shouldHaveOverflowY = documentHeight > viewportHeight

    return false
      || shouldHaveOverflowY
      || isScrollbarForced(body)
      || isScrollbarForced(html)
  }

  function isScrollbarForced(elm) {
    return 'scroll' === window.getComputedStyle(elm).overflowY
  }
}
